import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';

export const createWhatsAppTemplate = async (
  payload: import('./payload').WhatsAppTemplatePayload
) => {
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    endpoints.whatsappTemplates,
    payload
  );
  return response.data;
};

export const syncWhatsAppTemplates = async () => {
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    endpoints.whatsappTemplatesSync
  );
  return response.data;
};
